(function() {
'use strict';

angular.module('GorillaBoy.FileBrowser')
.factory('FavoritesService', ['$http', 'EndpointService', '$q', 'localStorageService', 'AppConstants', favoritesService]);

function favoritesService($http, EndpointService, $q, localStorageService, AppConstants) {
    var MAX_LIMIT = 50,
        httpMethods = AppConstants.HttpMethods,
        FAVORITES_FILE_NAME = 'gb_user_favorites',
        apiRoot = EndpointService.endpoint(true);

    function userFavorites(marker) {
        return $http(EndpointService.tokenize({
            url : apiRoot + 'favorites',
            method : httpMethods.GET,
            params : {
                marker : marker,
                limit : MAX_LIMIT
            }
        }));
    }

    var service = {
        getCachedUserFavorites : function() {
            return $q(function(resolve, reject) {
                var favs = localStorageService.get(FAVORITES_FILE_NAME);
                if (favs) {
                    resolve((favs));
                    return;
                }
                service.getUserFavorites().then(resolve, reject);
            });
        },
        createFav : function(resourceId, resourceType) {
            return $http(EndpointService.tokenize({
                url : apiRoot + 'favorites',
                method : httpMethods.POST,
                data : {
                    EntityId : resourceId,
                    EntityType : resourceType
                }
            })).then(function(response) {
                //Delete the stale cache
                localStorageService.remove(FAVORITES_FILE_NAME);
                return response;
            });
        },
        deleteFav : function(resourceId, resourceType) {
            return $http(EndpointService.tokenize({
                url : apiRoot + 'favorites?entityId=' + encodeURIComponent(resourceId) + '&entityType=' + encodeURIComponent(resourceType),
                method : httpMethods.DELETE
            })).then(function(response) {
                //Delete the stale cache
                localStorageService.remove(FAVORITES_FILE_NAME);
                return response;
            });
        },
        getUserFavorites : function() {
            return $q(function(resolve, reject) {
                var resultData = {
                    Folders : [],
                    Documents : []
                };

                function errorCallback() {
                    reject(false);
                }

                function successCallback(response) {
                    var data = response.data;
                    // user union to merge the current result with new result because the resource ids in the response
                    // can be duplicated. See details: https://tt.amazon.com/0151180194
                    resultData.Folders = _.union(resultData.Folders, data.Folders);
                    resultData.Documents = _.union(resultData.Documents, data.Documents);
                    if (data.Marker) {
                        userFavorites(data.Marker).then(successCallback, errorCallback);
                    } else {
                        localStorageService.set(FAVORITES_FILE_NAME, JSON.stringify(resultData));
                        resolve(resultData);
                    }
                }
                userFavorites().then(successCallback, errorCallback);
            });
        }
    };
    return service;
}

})();
